export const HeaderPanel = {
  ProfilePanel: 'ProfilePanel',
  SettingsPanel: 'SettingsPanel',
  HelpPanel: 'HelpPanel',
  NotificationPanel: 'NotificationPanel',
  FeedbackPanel: 'FeedbackPanel',
} as const;

export type HeaderPanel = typeof HeaderPanel[keyof typeof HeaderPanel];
